export default __webpack_public_path__ + "static/birgitta-854c155ad2c86a0a38d5afd9f5763b37.png";